import { GOOGLE_MAPS_URL, APPLE_MAPS_URL } from "../Aux/businessInfo";

export const mapSelector = () => {
    const isAppleDevice =
        navigator.platform.indexOf("iPhone") !== -1 ||
        navigator.platform.indexOf("iPad") !== -1 ||
        navigator.platform.indexOf("iPod") !== -1;

    window.open(isAppleDevice ? APPLE_MAPS_URL : GOOGLE_MAPS_URL);
};
